export default "__VITE_ASSET__CI0PHzsq__"